import {
  Checkbox,
  FormControl,
  Grid,
  Input,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/styles";
import {
  currentSectionState,
  formState,
  openSectionState,
} from "../../store/form.store";
import {
  extractDropDownValue,
  extractCommentValue,
  extractImageValue,
  extractAiFlags,
} from "../../store/form.answer.extract";
import { dropDownAnswer } from "../../store/form.answer.fill";
import { FORM_STATUS } from "../../utilities/Constants";
import { AiStatusOverlay } from "../../../components/AiStatusOverlay";

const styles = (theme) => ({
  userResponseFont: {
    fontSize: "15px",
  },
  formControl: {
    borderRadius: 4,
    border: "1px solid grey",
    padding: "10px",
    width: "92%",
  },
  underline: {
    "&&&:before": {
      borderBottom: "none",
    },
    "&&:after": {
      borderBottom: "none",
    },
  },
  commentText: {
    color: "#00000094",
    fontSize: "14px",
  },
});

export class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValues: [],
      editable: false,
      // helpTextValue: "",
      imageValue: [],
      options: this.props.element.options,
      checkedAllOptions: false,
      optionIds: [],
      isMultiple: this.props.element.properties.multiple,
      commentValue: "",
      disabled: false,
      aiFlags: {},
    };
  }

  componentDidMount() {
    let expanded = "";
    this.sectionStateSubscription = openSectionState.subscribe((sectionId) => {
      expanded = sectionId;
    });
    this.currentSectionSubscription = currentSectionState.subscribe(
      (section) => {
        this.setState({ editable: section === expanded });
      },
    );
    this.onLoadPage(this.props);
    // if (this.props.element.properties.answerLabel) {
    //   this.onLoadHelpText(this.props);
    // }
    if (
      this.props.element.properties.allowFileUpload ||
      this.props.element.properties.conditional
    ) {
      this.onLoadImage(this.props);
    }
    if (this.props.element.properties.conditional) {
      this.onLoadComment(this.props);
    }
    let options = [];
    this.props.element.options.forEach((option) => {
      if (!options.includes(option)) {
        options.push(option);
      }
    });
    this.setState({
      options: options,
    });
    // Disable the radio group if the status is 'Completed' on the review page.
    // The 'Rejected', 'In-Progress', and 'Active' statuses will not allow the edit option for the entire section.
    this.sectionformDetails = formState.subscribe((item) => {
      this.setState({ disabled: item.formStatus === FORM_STATUS.COMPLETED });
    });
  }

  componentWillUnmount() {
    this.sectionStateSubscription.unsubscribe();
    this.currentSectionSubscription.unsubscribe();
    this.sectionformDetails.unsubscribe();
  }

  onLoadImage(props) {
    if (props.element) {
      let image = props.element?.answer;
      let imageResponse = extractImageValue(image);
      if (imageResponse) {
        this.setState({
          imageValue: imageResponse,
        });
      }
      this.setState({ aiFlags: extractAiFlags(props.element?.answer) });
    }
  }

  // onLoadHelpText(props) {
  //   const answerLabel = props.element.properties.answerLabel;
  //   if (answerLabel) {
  //     this.setState({ helpTextValue: answerLabel });
  //   }
  // }

  onLoadComment(props) {
    if (props.element) {
      let answer = props.element?.answer;
      let commentResponse = extractCommentValue(answer);
      if (commentResponse) {
        this.setState({
          commentValue: commentResponse,
        });
      }
    }
  }

  onLoadPage(props) {
    if (props.element) {
      let answer = props.element.answer;
      let userResponse = extractDropDownValue(answer);
      if (userResponse) {
        this.setState({
          selectedValues: userResponse,
        });
      }
    }
  }

  onChangeOption = (event) => {
    let options = [];
    if (event.target.value.includes("all")) {
      if (this.state.optionIds.length === this.state.options.length) {
        this.setState({ optionIds: [], checkedAllOptions: false });
      } else {
        this.setState({
          checkedAllOptions: true,
          optionIds: this.state.options.map((option) => option.value),
        });
        options = this.state.options.map((option) => option.value);
      }
    } else {
      if (this.state.isMultiple) {
        options = event.target.value;
      } else {
        options = [event.target.value];
      }
      this.setState({
        optionIds: options,
        checkedAllOptions: false,
      });
    }
    if (this.props.onChange !== undefined) {
      this.props.onChange(
        dropDownAnswer(options, this.state.commentValue, this.state.imageValue),
        this.props.element,
      );
    }
  };

  selectedOptions = (values) => {
    return values?.length
      ? Array.isArray(values)
        ? values.join(", ")
        : values
      : "Please select a value";
  };

  render() {
    const { classes } = this.props;
    const selectedValues = Array.isArray(this.state.selectedValues)
      ? this.state.selectedValues
      : [];
    return (
      <Fragment>
        {this.state.editable ? (
          <Grid item md={12} xs={12}>
            <FormControl
              fullWidth
              variant="outlined"
              className={classes.formControl}
              style={{
                border:
                  this.props.hasError && !this.state.optionIds.length
                    ? "1px solid red"
                    : "1px solid grey",
              }}
            >
              <Select
                label="Select Option"
                className={classes.underline}
                id="options"
                name="options"
                multiple={this.state.isMultiple}
                value={
                  Array.isArray(this.state.optionIds) &&
                  this.state.optionIds.length
                    ? this.state.optionIds
                    : Array.isArray(this.state.selectedValues) &&
                        this.state.selectedValues.length
                      ? this.state.selectedValues
                      : []
                }
                onChange={this.onChangeOption}
                input={
                  <Input
                    value={
                      this.state.optionIds?.length
                        ? this.state.optionIds.join(", ")
                        : this.state.selectedValues.join(", ")
                    }
                  />
                }
                displayEmpty={true}
                renderValue={(selected) => this.selectedOptions(selected)}
                disabled={!this.state.options.length || this.state.disabled}
              >
                {this.state.options.length > 0 && this.state.isMultiple ? (
                  <MenuItem key="all" value="all">
                    <Checkbox checked={this.state.checkedAllOptions} />
                    <ListItemText primary="Select All" />
                  </MenuItem>
                ) : null}

                {this.state.options.map((option, index) =>
                  typeof option === "object" && option !== null ? (
                    <MenuItem key={index} value={option.value}>
                      {this.state.isMultiple ? (
                        <Checkbox
                          checked={
                            this.state.optionIds.indexOf(option.value) > -1
                          }
                        />
                      ) : null}
                      <ListItemText primary={option.value} />
                    </MenuItem>
                  ) : (
                    <MenuItem key={index} value={option}>
                      {this.state.isMultiple ? (
                        <Checkbox
                          checked={this.state.optionIds.indexOf(option) > -1}
                        />
                      ) : null}
                      <ListItemText primary={option} />
                    </MenuItem>
                  ),
                )}
              </Select>
            </FormControl>
          </Grid>
        ) : (
          <Grid item md={12} xs={12}>
            <Typography className={classes.userResponseFont}>
              {selectedValues.map((selectedValue, index) => {
                const displayValue =
                  typeof selectedValue === "string"
                    ? selectedValue
                    : selectedValue && typeof selectedValue === "object"
                      ? selectedValue.name || selectedValue.value || ""
                      : "";
                return index !== selectedValues.length - 1
                  ? displayValue + ", "
                  : displayValue + " ";
              })}
            </Typography>
          </Grid>
        )}
        {/* {this?.state?.helpTextValue && (
          <FormHelperText>{this.state.helpTextValue}</FormHelperText>
        )} */}
        <Grid item md={12} xs={12}>
           {this.props.element.properties.conditional &&
          this.state.commentValue !== "" ? (
            <Typography className={classes.commentText}>
              {this.state.commentValue}
            </Typography>
          ) : null}
          {(this.props.element.properties.allowFileUpload ||
            this.props.element.properties.conditional) &&
          this.state.imageValue.length > 0 ? (
            <AiStatusOverlay
              imageList={this.state.imageValue}
              aiVerificationStatus={this.state.aiFlags.aiVerificationStatus}
              aiVerificationMessage={this.state.aiFlags.aiVerificationMessage}
            />
          ) : null}
        </Grid>
      </Fragment>
    );
  }
}
export default withStyles(styles)(Dropdown);
